// extracted by mini-css-extract-plugin
var _1 = "_S66hZ9Z";
var _2 = "bzFdJKoU";
var _3 = "bzFdJKoU";
var _4 = "ItUnnRzD";
var _5 = "FwX3_YZh";
var _6 = "WmFOvoFH";
var _7 = "CXU6urM1";
var _8 = "mAnLtqq8";
export { _1 as "definition", _2 as "definition-info", _3 as "definitionInfo", _4 as "details", _5 as "summary", _6 as "synonyms", _7 as "title", _8 as "typeName" }
